import { DollarSign, Activity, TrendingUp, Wallet } from 'lucide-react'

interface CostKPIsProps {
  balance: number | null
  costToday: number
  cost7d: number
  cost30d: number
  callsToday: number
  ratesAvailable: boolean
}

export default function CostKPIs({ balance, costToday, cost7d, cost30d, callsToday, ratesAvailable }: CostKPIsProps) {
  const kpis = [
    {
      label: 'Balance DataForSEO',
      value: balance !== null ? `$${balance.toFixed(2)}` : 'N/A',
      icon: Wallet,
      color: 'text-emerald-600',
      bgColor: 'bg-emerald-500/10',
    },
    {
      label: "Coût aujourd'hui",
      value: `$${costToday.toFixed(4)}`,
      sub: `${callsToday} appels`,
      icon: DollarSign,
      color: 'text-indigo-600',
      bgColor: 'bg-indigo-500/10',
    },
    {
      label: 'Coût 7 jours',
      value: `$${cost7d.toFixed(4)}`,
      icon: TrendingUp,
      color: 'text-blue-600',
      bgColor: 'bg-blue-500/10',
    },
    {
      label: 'Coût 30 jours',
      value: `$${cost30d.toFixed(4)}`,
      icon: Activity,
      color: 'text-amber-600',
      bgColor: 'bg-amber-500/10',
    },
  ]

  return (
    <div>
      {!ratesAvailable && (
        <div className="mb-4 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2 text-sm text-amber-700">
          Tarifs DataForSEO non disponibles — coûts estimés avec les derniers tarifs connus
        </div>
      )}
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {kpis.map((kpi) => (
          <div key={kpi.label} className="bg-white border border-[#E2E4ED] rounded-xl p-5">
            <div className="flex items-center gap-3">
              <div className={`rounded-lg p-2.5 ${kpi.bgColor}`}>
                <kpi.icon className={`h-5 w-5 ${kpi.color}`} />
              </div>
              <div>
                <p className="text-sm text-[#8B8FA7]">{kpi.label}</p>
                <p className="text-xl font-semibold text-[#1B2559]">{kpi.value}</p>
                {'sub' in kpi && kpi.sub && <p className="text-xs text-[#8B8FA7]">{kpi.sub}</p>}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
